<template>
    <span v-if="canShowPencil">
        <v-btn
            icon
            x-small
            color="primary"
            class="ml-1"
            @click.stop="openDialog"
        >
            <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="500px" persistent>
            <v-card :loading="loading">
                <v-card-title>
                    <v-btn
                        small
                        icon
                        @click="close"
                        color="primary"
                        class="ml-n3 mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <h2 class="font-weight-regular">
                        EDIT FINISH & UC CODE
                    </h2>
                </v-card-title>
                <v-divider class="ml-4 mr-5" />
                <v-card-text>
                    <p class="mb-2 mt-2">
                        <strong>Part Number:</strong>
                        {{ item.partNumber || item.partNumberId || item.id }}
                    </p>
                    <v-form v-model="valid" class="mt-2 mb-0">
                        <v-combobox
                            v-model="selectedFinish"
                            :items="finishes"
                            item-text="name"
                            item-value="id"
                            prepend-icon="mdi-barcode"
                            label="Finish & UC Code: *"
                            :rules="[rules.required]"
                            required
                        />
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        rounded
                        color="primary"
                        class="mb-5 mt-n4"
                        @click="save"
                        :disabled="!canSave"
                        :loading="loading"
                    >
                        SAVE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import API from '@/services/api'
import { mapMutations } from 'vuex'
import { selectableFinishes } from '@/helpers/selectableFinishes.js'

const ALLOWED_STATUSES = [
    'inProgress',
    'sent',
    'approved',
    'finished',
    'rejected',
]

// TEMPORARY: remove when temp finish edit feature is retired
export default {
    name: 'TempEditFinishAndUCCode',
    props: {
        item: {
            type: Object,
            required: true,
        },
        workOrder: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            default: () => ({}),
        },
        settingFinish: {
            type: Object,
            default: () => ({}),
        },
        finishAndUcCodeData: {
            type: Object,
            default: () => ({}),
        },
    },
    data: () => ({
        dialog: false,
        selectedFinish: null,
        loading: false,
        valid: false,
        rules: {
            required: value => !!value || 'Required.',
        },
    }),
    computed: {
        finishes() {
            return selectableFinishes(
                this.settingFinish?.finishes,
                this.item.finishAndUCCode
            )
        },
        hasEditSettingsPermission() {
            return (
                Array.isArray(this.user?.permissions) &&
                this.user.permissions.includes('editSettings')
            )
        },
        canShowPencil() {
            if (!this.hasEditSettingsPermission) return false
            if (this.user.name === 'AnonymousSession') return false
            return ALLOWED_STATUSES.includes(this.workOrder?.status)
        },
        canSave() {
            return (
                this.valid &&
                this.selectedFinish &&
                typeof this.selectedFinish === 'object' &&
                !!this.selectedFinish.id
            )
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        openDialog() {
            if (!this.canShowPencil) return
            if (this.item.finishAndUCCode) {
                this.selectedFinish =
                    this.finishAndUcCodeData[this.item.finishAndUCCode] ||
                    this.finishes.find(
                        finish => finish.id == this.item.finishAndUCCode
                    ) ||
                    null
            } else {
                this.selectedFinish = null
            }
            this.dialog = true
        },
        close() {
            this.dialog = false
            this.selectedFinish = null
        },
        async save() {
            if (!this.canShowPencil || !this.canSave) return
            try {
                this.loading = true
                const partNumberId =
                    this.item.partNumberId || this.item.id
                await API.tempUpdateWorkOrderItemFinishAndUCCode({
                    workOrderId: this.workOrder.id,
                    partNumberId,
                    finishAndUCCode: this.selectedFinish.id,
                    settingFinishId: this.settingFinish.id,
                })
                this.$emit('updated', {
                    ...this.item,
                    finishAndUCCode: this.selectedFinish.id,
                })
                this.close()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
